<template>
  <div>
    <LoadingBusy :loading="loading" :isAuthenticating="false" text="Loading, please wait...">
    </LoadingBusy>
    <div class="locations">
      <div id="selectedLocation" class="light-blue darken-4 white--text pa-2">
        <span>
          <span>Selected Location</span>
        </span>
      </div>
      <table dense style="border: 1px solid">
        <thead>
          <tr>
            <th class="text-left white--text text-subtitle-1">Selected Location</th>
            <th class="text-left white--text text-subtitle-1">Proximity</th>
            <th class="text-left white--text text-subtitle-1">Next Available Date</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="text-subtitle-1 font-weight-black">{{ selectlocation.Name }}</div>
              <div>{{ selectlocation.Address }}</div>
            </td>
            <td>{{ selectlocation.Distance }} miles away
              <span>(<a :href="selectlocation.MapUrl" target="_blank">Map</a>)
              </span>
            </td>
            <td>{{ selectlocation.NextAvailableDate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="locations mt-12" v-if="displayOtherLocations">
      <div class="light-blue darken-4 white--text pa-2 px-6">
        <span>Other Suggested Locations</span>
        <span
          style="cursor:pointer"
          class="float-right pl-2"
          @click="displayHideLocations()" @keydown="displayHideLocations()"
        >
          <v-icon v-if="!expandedLocations" class="white--text">mdi-plus</v-icon>
          <v-icon v-else class="white--text">mdi-minus</v-icon>
        </span>
      </div>
      <table dense style="border: 1px solid" v-if="expandedLocations">
        <tbody>
          <tr v-for="location in filteredLocationList" :key="location.Id">
            <td>
              <div class="text-subtitle-1 font-weight-black">{{ location.Name }}</div>
              <div>{{ location.Address }}</div>
            </td>
            <td>{{ location.Distance }} miles away
              <span>(<a :href="location.MapUrl" target="_blank">Map</a>)
              </span>
            </td>
            <td>{{ location.NextAvailableDate }}
            </td>
            <td style="cursor:pointer !important;"
              @click="selectLocation(location)" @keydown="selectLocation(location)">
              <v-icon large>mdi-chevron-double-right</v-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-12 text-center">
      <div class="pa-2 px-6 light-blue darken-4 white--text">
        <span>
          Select from the available dates at {{ selectlocation.Name }} - {{ testTypeText }}
        </span>
        <span
          style="cursor:pointer"
          class="float-right pl-2"
          @click="displayHideDates()" @keydown="displayHideDates()"
        >
          <v-icon v-if="!expandedDates" class="white--text">mdi-plus</v-icon>
          <v-icon v-else class="white--text">mdi-minus</v-icon>
        </span>
      </div>
      <table class="dates" dense style="border: 1px solid" v-if="expandedDates">
        <tbody>
          <tr>
            <td
              class="carousel-left"
              @click="MoveDateCarousel(-1)" @keydown="MoveDateCarousel(-1)"
              :class="atHeadOfList ? 'carousel-disabled' : ''"
              :disabled="atHeadOfList"
            >
              <div class="text-center" style="width:100% !important">
                <v-icon>mdi-chevron-double-left</v-icon>
              </div>
            </td>
            <td>
              <v-layout row wrap justify-md-center>
                <v-flex
                  class="md2 sm4 xs6"
                  v-for="item in visibleDates"
                  :key="item.FormattedAvailabilityDate"
                >
                  <div class="card ma-4 text-center"
                       :class="
                        item.FormattedAvailabilityDate === formattedAvailableDate
                          ? 'blue darken-2'
                          : 'blue lighten-2'
                      "
                       @click="selectLocationDate(item)" @keydown="selectLocationDate(item)"
                       style="cursor:pointer !important;">
                    <div class="text-center font-weight-medium pt-2">{{ item.DayOfWeek }}</div>
                    <div class="text-center white--text pt-2">
                      {{item.FormattedAvailabilityDate}}
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </td>
            <td
              class="carousel-left"
              @click="MoveDateCarousel(1)" @keydown="MoveDateCarousel(1)"
              :class="atEndOfList && !moreDatesAvailable ? 'carousel-disabled' : ''"
              :disabled="atEndOfList && !moreDatesAvailable"
            >
              <div class="text-center" style="width:100% !important">
                <v-icon>mdi-chevron-double-right</v-icon>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-12 text-center" v-if="isSelectTime">
      <div class="pa-2 px-6 light-blue darken-4 white--text">
        <span>
        Select from the available times at
       {{ selectlocation.Name }} - {{ testTypeText }} for {{ formattedAvailableDate }}
       </span>
       <span
          style="cursor:pointer"
          class="float-right pl-2"
          @click="displayHideTimes()" @keydown="displayHideTimes()"
        >
          <v-icon v-if="!expandedTimes" class="white--text">mdi-plus</v-icon>
          <v-icon v-else class="white--text">mdi-minus</v-icon>
        </span>
      </div>
      <table class="dates" dense style="border: 1px solid" v-if="expandedTimes">
        <tbody>
          <tr>
            <td
              class="carousel-left pr-4"
              :class="atHeadOfSlotList ? 'carousel-disabled' : ''"
              :disabled="atHeadOfSlotList"
              @click="moveTimeSlotCarousel(-1)"
              @keydown="moveTimeSlotCarousel(-1)"
            >
              <div class="text-center" style="width:100% !important">
                <v-icon>mdi-chevron-double-left</v-icon>
              </div>
            </td>
            <td class="slots">
              <v-layout row wrap>
                <v-flex class="md2 sm4 xs6" v-for="slot in visibleTimeSlots" :key="slot.SlotId">
                  <div
                    class="pa-2 mx-2 my-3 text-center slot-card"
                    :class="
                      slot.FormattedTime === selecttimeslot.FormattedTime
                        ? 'blue-grey lighten-2'
                        : 'blue-grey lighten-4'
                    "
                    @click="selectTimeSlot(slot)"
                    @keydown="selectTimeSlot(slot)"
                  >
                    <div class="text-center font-weight-medium mt-5">{{ slot.FormattedTime }}</div>
                  </div>
                </v-flex>
              </v-layout>
            </td>
            <td
              class="carousel-right"
              @click="moveTimeSlotCarousel(1)"
              :class="atEndOfSlotList ? 'carousel-disabled' : ''"
              :disabled="atEndOfSlotList"
              @keydown="moveTimeSlotCarousel(1)"
            >
              <div class="text-center" style="width:100% !important">
                <v-icon>mdi-chevron-double-right</v-icon>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pa-4">
      If you are having difficulty scheduling an appointment on a preferred day, please know all DL
      offices do have a limited number of same-day appointments available on a first-come, first
      served basis, and that fill up quickly. Customers who book these appointments at the office
      can then leave and return at their designated appointment time.
    </div>
    <div class="text-center btn-container">
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
          class="ma-2"
          color="primary"
          @click="previousClick()"
          ><v-icon>mdi-arrow-left</v-icon>
          PREVIOUS
        </v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn
          class="ma-2"
          color="primary"
          :disabled="nextDisabled"
          @click="nextClick()"
        >
          NEXT
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        </v-col>
      </v-row>
      <div>
      <v-alert
        class="ma-2"
        type="error"
        :value="isError"
        dense
        outlined
        dismissible
        transition="scale-transition"
      >
        {{ errorMessage }}
      </v-alert>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoadingBusy from '../components/LoadingBusy.vue';
import scApi from '../api/scApi';

export default {
  components: {
    LoadingBusy,
  },
  data() {
    return {
      loading: false,
      selectlocation: '',
      locationApi: '',
      locationAvailabilityApi: '',
      currentDatePage: 1,
      locationAvailabilityDates: [],
      moreDatesAvailable: false,
      nextAvailableGroupDate: '',
      locationId: '',
      nextDisabled: true,
      isSelectTime: false,
      formattedAvailableDate: '',
      slotPage: 1,
      availableTimeSlots: [],
      selecttimeslot: '',
      isError: false,
      errorMessage: '',
      expandedTimes: true,
      expandedDates: true,
      expandedLocations: true,
    };
  },
  methods: {
    ...mapActions({
      selectedLocationAction: 'selectedLocation',
    }),
    ...mapActions('bookingDetails', {
      siteNameAction: 'siteName',
      siteAddressAction: 'siteAddress',
      formattedCheckinDateTimeAction: 'formattedCheckinDateTime',
      slotIdAction: 'slotId',
      siteIdAction: 'siteId',
      bookingDateTimeAction: 'bookingDateTime',
      bookingDurationAction: 'bookingDuration',
    }),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    async selectLocation(location) {
      console.log('Inside selectLocation');
      console.log(this.beginDate);
      this.currentDatePage = 1;
      this.selectlocation = location;
      this.locationId = location.Id;
      this.loading = true;
      const beginDate = new Date(this.beginDate);
      try {
        [this.locationApi, this.locationAvailabilityApi] = await Promise.all([
          scApi.GetLocation(location.Id),
          scApi.GetLocationAvailability(
            location.Id,
            this.testTypeId,
            false,
            0,
            beginDate,
          ),
        ]);
        this.locationAvailabilityDates = this.locationAvailabilityApi.LocationAvailabilityDates;
        this.moreDatesAvailable = this.locationAvailabilityApi.MoreDatesAvailable;
        this.nextAvailableGroupDate = this.locationAvailabilityApi.NextAvailableGroupDate;
        console.log(this.locationApi);
        console.log(this.locationAvailabilityApi);
      } catch (error) {
        console.log(error);
        this.isError = true;
        this.errorMessage = error;
      } finally {
        console.log('Inside selectLocation finally');
        this.loading = false;
      }
    },
    UpdateDatePage(direction) {
      this.currentDatePage += direction;
    },
    async GetMoreAvailableDates() {
      console.log('Inside GetMoreAvailableDates');
      this.loading = true;
      try {
        this.locationAvailabilityApi = await scApi.GetLocationAvailability(
          this.locationId,
          this.testTypeId,
          false,
          0,
          this.nextAvailableGroupDate,
        );
        const lada = this.locationAvailabilityApi.LocationAvailabilityDates;
        this.locationAvailabilityDates = this.locationAvailabilityDates.concat(lada);
        this.moreDatesAvailable = this.locationAvailabilityApi.MoreDatesAvailable;
        this.nextAvailableGroupDate = this.locationAvailabilityApi.NextAvailableGroupDate;
        console.log(this.locationAvailabilityApi);
      } catch (error) {
        console.log(error);
        this.isError = true;
        this.errorMessage = error;
      } finally {
        console.log('Inside GetMoreAvailableDates finally');
        this.loading = false;
      }
    },
    async MoveDateCarousel(direction) {
      // Find a more elegant way to express the :style.
      // Consider using props to make it truly generic
      // Call service here with new date //
      console.log('Inside MoveDateCarousel');
      if (direction === 1 && (!this.atEndOfList || this.moreDatesAvailable)) {
        // Get next 5 time slots available
        const lastDateDisplayed = this.visibleDates && this.visibleDates.length > 0
          ? this.visibleDates[this.visibleDates.length - 1].AvailabilityDate
          : null;
        // console.log(this.lastDateAvailable);
        // console.log(lastDateDisplayed);
        // const isLastDateDisplayed = this.lastDateAvailable === lastDateDisplayed;

        this.UpdateDatePage(1);
        // if (isLastDateDisplayed || this.visibleDates.length < 5) {
        if (this.moreDatesAvailable) {
          this.nextAvailableGroupDate = this.nextAvailableGroupDate || lastDateDisplayed;
          await this.GetMoreAvailableDates();
        }
        // this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        // this.currentOffset += this.paginationFactor;
        this.UpdateDatePage(-1);
      }
      console.log('Exit MoveDateCarousel');
    },
    selectLocationDate(locationDate) {
      console.log(locationDate);
      this.availableTimeSlots = locationDate.AvailableTimeSlots;
      this.formattedAvailableDate = locationDate.FormattedAvailabilityDate;
      this.selectedLocationAction({ value: this.selectlocation });
      // this.$emit('navigateTo', 'SelectTime');
      this.isSelectTime = true;
    },
    previousClick() {
      // console.log('Inside previousClick');
      if (this.isSelectTime) {
        this.isSelectTime = false;
      } else {
        this.$emit('navigateTo', 'CustomerDetailsPage');
      }
    },
    moveTimeSlotCarousel(direction) {
      if (direction === 1 && !this.atEndOfSlotList) {
        this.slotPage += 1;
      } else if (direction === -1 && !this.atHeadOfSlotList) {
        this.slotPage -= 1;
      }
    },
    selectTimeSlot(timeSlot) {
      console.log(timeSlot);
      this.selecttimeslot = timeSlot;
      this.nextDisabled = false;
    },
    async nextClick() {
      console.log(this.selectlocation);
      this.siteIdAction({ value: this.selectlocation.Id });
      this.siteNameAction({ value: this.selectlocation.Name });
      this.siteAddressAction({ value: this.selectlocation.Address });
      this.formattedCheckinDateTimeAction({
        value: this.selecttimeslot.FormattedStartDateTime,
      });
      this.slotIdAction({ value: this.selecttimeslot.SlotId });
      this.bookingDateTimeAction({ value: this.selecttimeslot.StartDateTime });
      this.bookingDurationAction({ value: this.selecttimeslot.Duration });
      this.loading = true;
      try {
        const holdBookingResult = await scApi.HoldBookingSlot(
          this.selecttimeslot.SlotId,
          this.dLNumber,
        );
        console.log(holdBookingResult);
        if (holdBookingResult && holdBookingResult.SlotHeldSuccessfully) {
          this.$emit('navigateTo', 'SummaryPage');
        }
      } catch (error) {
        console.log(error);
        this.isError = true;
        this.errorMessage = error;
      } finally {
        console.log('Inside HoldBookingSlot finally');
        this.loading = false;
      }
    },
    displayHideTimes() {
      this.expandedTimes = !this.expandedTimes;
    },
    displayHideDates() {
      this.expandedDates = !this.expandedDates;
    },
    displayHideLocations() {
      this.expandedLocations = !this.expandedLocations;
    },
  },
  computed: {
    ...mapGetters('userInfo', ['testTypeText', 'testTypeId', 'dLNumber']),
    ...mapGetters(['availableLocation', 'selectedLocation']),
    ...mapGetters(['beginDate']),
    filteredLocationList() {
      const filteredLocations = [];
      if (this.availableLocation) {
        const locations = this.availableLocation;
        // console.log(locations);
        locations.forEach((location) => {
          if (location.Id !== this.selectlocation.Id) {
            filteredLocations.push(location);
          }
        });
      }
      return filteredLocations;
    },
    lastDateAvailable() {
      console.log('Inside lastDateAvailable');
      const length = this.locationAvailabilityDates.length - 1;
      return this.locationAvailabilityDates[length].AvailabilityDate;
    },
    visibleDates() {
      console.log('Inside visibleDates');
      const dates = this.locationAvailabilityDates;
      console.log(dates);
      const visibleDates = [];
      if (dates && dates.length > 0) {
        let i = 0;
        let pageCount = 1;
        dates.forEach((date) => {
          i += 1;
          if (pageCount === this.currentDatePage && i <= 5) {
            visibleDates.push(date);
          }
          if (i >= 5) {
            i = 0;
            pageCount += 1;
          }
        });
      }
      console.log(visibleDates);
      console.log('Exit visibleDates');
      return visibleDates;
    },
    atEndOfList() {
      console.log('Inside atEndOfList');
      return this.locationAvailabilityDates.length / (5 * this.currentDatePage) <= 1;
    },
    atHeadOfList() {
      console.log('Inside atHeadOfList');
      return this.currentDatePage === 1;
    },
    atHeadOfSlotList() {
      return this.slotPage === 1;
    },
    atEndOfSlotList() {
      let atEnd = false;
      if (this.availableTimeSlots !== undefined && this.availableTimeSlots !== null) {
        atEnd = (this.availableTimeSlots.length / (12 * this.slotPage) <= 1);
      }
      return atEnd;
    },
    visibleTimeSlots() {
      const slots = this.availableTimeSlots;
      const visibleSlots = [];
      if (slots && slots.length >= 1) {
        let i = 0;
        let pageCount = 1;
        slots.forEach((slot) => {
          i += 1;
          if (pageCount === this.slotPage && i <= 12) {
            visibleSlots.push(slot);
          }
          if (i === 12) {
            i = 0;
            pageCount += 1;
          }
        });
      }
      return visibleSlots;
    },
    displayOtherLocations() {
      return !this.isSelectTime && this.availableLocation.length > 1;
    },
  },
  mounted() {
    this.selectlocation = this.selectedLocation;
    const lad = this.availableLocation[0].Availability.LocationAvailabilityDates;
    this.locationAvailabilityDates = lad;
    const mda = this.availableLocation[0].Availability.MoreDatesAvailable;
    this.moreDatesAvailable = mda;
    const nag = this.availableLocation[0].Availability.NextAvailableGroupDate;
    this.nextAvailableGroupDate = nag;
    this.locationId = this.selectedLocation.Id;
  },
};
</script>

<style scoped>
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .display-sm-table {
    display: inline-block !important;
  }

  /* Force table to not be like tables anymore */
  .testResults table,
  .testResults thead,
  .testResults tbody,
  .testResults th,
  .testResults td,
  .testResults tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .testResults thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .testResults tr {
    border: 1px solid #ccc;
  }

  .testResults td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }

  .testResults td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }
}
thead {
  background-color: #004b8e;
}
/*tr:nth-child(even) {
  background-color: #f2f2f2;
}*/
</style>
